import React from 'react';
import Button from './button';

export default function createButtonVariant(displayName, size, rank) {
  const ButtonVariant = props => {
    return <Button size={size} rank={rank} {...props} />;
  };
  ButtonVariant.displayName = displayName;
  return ButtonVariant;
}
